<template>
  <div class="panel panel-default">
    <div class="panel-heading">
      <h5>
        {{ headline }}
      </h5>
    </div>

    <div class="panel-body">
      <form @submit.prevent="$emit('submit', data)">
        <TextFormGroup
            v-model="data.name"
            name="name"
            label="Name"
            help-text="The name of the article flag."
            :error="(errors.name || [])[0]"
        />

        <TextFormGroup
            v-model="data.color"
            name="color"
            label="Color"
            help-text="The color of the article flag."
            :error="(errors.color || [])[0]"
        />

        <RadioFormGroup
            v-model="data.is_promoted_in_newsletter"
            name="is_promoted_in_newsletter"
            label="Promoted In Newsletter"
            help-text="A flag indicating if the flag makes the articles promoted."
            :error="(errors.is_promoted_in_newsletter || [])[0]"
            :options="[{value: true, label:'Yes'}, {value: false, label: 'No'}]"
        />

        <SubmitFormGroup button-class="btn-black"/>
      </form>
    </div>
  </div>
</template>

<script>
import store from '@/store'
import RadioFormGroup from '@/vendor/forms/FormGroups/Block/Radio'
import SubmitFormGroup from '@/vendor/forms/FormGroups/Block/Submit'
import TextFormGroup from '@/vendor/forms/FormGroups/Block/Text'

export default {
  components: {RadioFormGroup, SubmitFormGroup, TextFormGroup},

  props: {
    headline: {
      required: true,
      type: String
    },

    initial: {
      required: false,
      type: Object,
      default: () => ({})
    },

    errors: {
      required: true,
      type: Object
    }
  },

  data() {
    return {
      data: {...this.initial},

      shared: store
    }
  }
}
</script>